import { doc, getDoc, setDoc, Timestamp } from 'firebase/firestore';
import { db } from './config';
import { BusinessInfo, BusinessInfoInput } from '@/types/business';

/**
 * 事業者情報サービスクラス
 * システム全体で1つの共有ドキュメント settings/business を直接読み書きする。
 * 書き込みは firestore.rules で管理者のみに制限される。
 */
export class BusinessService {
  private businessDocRef() {
    return doc(db, 'settings', 'business');
  }

  /**
   * 事業者情報を取得（ドキュメント未作成なら null）
   */
  async getBusinessInfo(): Promise<BusinessInfo | null> {
    try {
      const snapshot = await getDoc(this.businessDocRef());
      if (!snapshot.exists()) {
        return null;
      }
      return snapshot.data() as BusinessInfo;
    } catch {
      throw new Error('事業者情報の取得に失敗しました');
    }
  }

  /**
   * 事業者情報を保存（初回作成と更新を兼用）
   */
  async saveBusinessInfo(input: BusinessInfoInput, uid: string): Promise<void> {
    try {
      await setDoc(this.businessDocRef(), {
        businessName: input.businessName,
        kennelName: input.kennelName,
        updatedAt: Timestamp.now(),
        updatedBy: uid,
      });
    } catch {
      throw new Error('事業者情報の保存に失敗しました');
    }
  }
}

// シングルトンインスタンスをエクスポート
export const businessService = new BusinessService();
